import { Currency, formatBalance, formatDate } from '@ui/src';
import { ContractStatement } from '../types';

const formatContractStatementsList = (
  list: ContractStatement[],
): ContractStatement[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      createdAt: <div>{formatDate(item.createdAt, true)}</div>,
      currencyId: <div>{item?.currency?.name}</div>,
      sum: <div>{formatBalance(item.sum, item.currency as Currency)}</div>,
      creditSum: (
        <div>{item?.generalLedgerTransaction?.creditAccountNumber || '-'}</div>
      ),
      debitSum: (
        <div>{item?.generalLedgerTransaction?.debitAccountNumber || '-'}</div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatContractStatementsList;
